import axiosInstance from '../api/axios';
//sale details
export const getCustomerSales = async (params) => {
  try {
         const response = await axiosInstance.get('/customer/sales', {
           params: params
         });
         // Handle both paginated and non-paginated responses for backward compatibility
         if (response?.items && response.total !== undefined) {
           return response.items;
         } else if (Array.isArray(response)) {
           return response;
         }
         return [];
       } catch (error) {
         console.error('Error fetching customer sales:', error);
         throw error;
       }
   };

export const updateSales = async (customerSaleId, data) => {
  try {
      const response = await axiosInstance.put(`/customer/sales`, data, {
          
          params: { customerSaleId: customerSaleId },
      });
      return response;
  } catch (error) {
      console.error("Error updating sales:", error);
      throw error;
  }
};
//create a customer sale
export const createCustomerSales = async (saleData) => {
  try {
    const response = await axiosInstance.post('/customer/sales', saleData);
 
    return response;
  } catch (error) {
    console.error('Error creating customer sale:', error);
    throw error;
  }
};



//get installments details
export const getCustomerSalesInstallment = async (params) => {
  try {
    const response = await axiosInstance.get('/customer/sales/installment', {
      params: params
    });

    // Handle both paginated and non-paginated responses for backward compatibility
    if (response?.items && response.total !== undefined) {
      return response.items;
    } else if (Array.isArray(response)) {
      return response;
    }
    return [];
  } catch (error) {
    console.error('Error fetching customer sales installment:', error);
    throw error;
  }
};
//get slab sale details

export const getSlabPayment= async (property_id, total_amount) => {
  try {
    const response = await axiosInstance.get('/property/slab/payment-plan', {
      params: { property_id, total_amount  }  
    });
   
    return response;  
  } catch (error) {
    console.error('Error fetching slab sales payment:', error);
    throw error;
  }
};

/**
 * Save or update the per-sale custom slab percentages (Sales API).
 *
 * v2 (§D): the old `customer_sales_slab_plan` table + `PUT /customer/sales/slab-plan`
 * endpoint were DROPPED this run. Negotiated per-sale overrides now persist via
 * `PUT /api/sales/clp-overrides` (body `RequestClpOverride`: { customerSalesId, entries[] }
 * where each entry is { wbsStageId, order, particulars, percentConsideration, floorTarget }).
 * The stage FK is `wbsStageId` (sourced from the slab row PaymentTable emits) — no hardcoded
 * stage-id fallback.
 */
export const saveCustomSlabPlan = async (customerSalesId, slabRows) => {
  try {
    const entries = slabRows.map((row, index) => ({
      wbsStageId: row.wbsStageId ?? null,
      order: index + 1,
      percentConsideration: parseFloat(row.percentConsideration) || 0,
      particulars: row.paymentName || row.details || '',
      floorTarget: row.floorTarget ?? row.target ?? null
    }));
    const payload = { customerSalesId, entries };
    const response = await axiosInstance.put('/sales/clp-overrides', payload);
    return response;
  } catch (error) {
    console.error('Error saving custom slab plan:', error);
    throw error;
  }
};
export const getCurrency = async () => {
  try {
    const response = await axiosInstance.get("/currency");
    return response;
  } catch (error) {
    console.error("Failed to fetch currencies:", error);
    throw error; 
  }
};
export const getCustomerSalesCancellation = async (params) => {
  try {
         const response = await axiosInstance.get('/customer/sales/cancellation', {
           params: params
         });
           return response;
       } catch (error) {
         console.error('Error fetching customer cancellation  sales:', error);
         throw error;
       }
   };
   export const getCustomerSalesCancellationProof = async (params) => {
    try {
           const response = await axiosInstance.get('/customer/sales/cancellation/proof', {
             params: params
           });
             return response;
         } catch (error) {
           console.error('Error fetching customer cancellation  proof:', error);
           throw error;
         }
     };